import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SupportDocs from 'components/SupportDocs';
import { LoaderButton } from 'ctia-ui';
import { submitWizard } from 'actions/wizard';
import { submitEcoRequest } from 'actions/request';
import { showNotice } from 'actions/notifier';

class Documents extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false
    };
  }

  onSubmit = () => {
    // activate button preloader
    this.setState({
      isSubmitting: true
    });

    const { request, submitEcoRequest, submitWizard, model } = this.props;

    // add to request info about parent model
    const requestWithModel = {
      ...request,
      parentId: model.selectedVersion,
      parentModelId: model.info.id
    };

    submitEcoRequest(requestWithModel, submitWizard);
  };

  errorMessageCallback = message => {
    this.setState({ isSubmitting: false });
    this.props.showNotice(message);
  };

  render() {
    const { show, canSubmit, editMode } = this.props;

    if (!show) return null;

    return (
      <div>
        <SupportDocs editMode={editMode} />
        <hr />
        <div className="text-right">
          <LoaderButton
            disabled={false}
            bsStyle="success"
            text="Submit"
            isLoading={this.state.isSubmitting}
            onClick={this.onSubmit}
            show={canSubmit}
          />
        </div>
      </div>
    );
  }
}

Documents.propTypes = {
  show: PropTypes.bool,
  canSubmit: PropTypes.bool,
  editMode: PropTypes.bool
};

Documents.defaultProps = {
  show: true,
  canSubmit: false
};

function mapStateToProps({ request, user, model }) {
  return { request, user, model };
}

export default connect(
  mapStateToProps,
  {
    submitWizard,
    submitEcoRequest,
    showNotice
  }
)(Documents);



// WEBPACK FOOTER //
// ./src/containers/request/ECO/Documents.js